module.exports = __webpack_public_path__ + "static/img/lsb.e6a65ce.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bank/lsb.png
// module id = h2jb
// module chunks = 93